import { getToken } from "./tokenAquirer";

// This function fetches data from an API endpoint with token refresh handling
// It was created to capture 401 errors and retry the request with a new token

// apiHelper.js
export const fetchWithAuth = async (
  url,
  options,
  instance,
  account,
  inProgress,
) => {
  const tokenData = await getToken(instance, account, inProgress); // Get the token

  // Add token to headers
  const headers = new Headers({
    Authorization: `Bearer ${tokenData}`,
    "Content-Type": "application/json",
    ...options.headers,
  });

  // Make the initial request
  let res = await fetch(url, {
    ...options,
    headers,
  });

  // If 401 error occurs, try refreshing the token and retry the request
  if (res.status === 401) {
    console.error("API returned 401. Token may be expired.");
    try {
      const refreshedToken = await getToken(instance, account, inProgress); // Refresh token

      // Retry with the new token
      headers.set("Authorization", `Bearer ${refreshedToken}`);
      res = await fetch(url, {
        ...options,
        headers,
      });
    } catch (error) {
      console.error("Token refresh failed:", error);
      throw error;
    }
  }

  // Return the response
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};
